// Generated by tools/generate-internal-test-avatar.mjs; owner-mandated fixed test pricing.
export const INTERNAL_TEST_AVATAR_ID = "47fae7f66a58987201e29e794f52e4de";
export const SECOND_INTERNAL_TEST_AVATAR_ID = "650815a96ab53a2800d7ac442736f096";
export const INTERNAL_TEST_AVATAR_IDS = ["47fae7f66a58987201e29e794f52e4de","650815a96ab53a2800d7ac442736f096"] as const;
export const INTERNAL_TEST_PRICE_FEN = 1;
export function isInternalTestAvatarId(id: string) {
  return INTERNAL_TEST_AVATAR_IDS.some(testId => testId === id);
}
